import FirebaseAuthUI from 'components/core/controllers/views/FirebaseAuthUI';
import React from 'react';
import { defaultFirebaseAuthConfig } from 'tools/libraries/firebaseAuth';

export default function FirebaseLogin(): JSX.Element {
  return <FirebaseAuthUI {...defaultFirebaseAuthConfig} publicPage />;
}
